import React from "react";
import OnBoardHome from "components/onboard/OnBoardHome";

function OnBoardPage () {
  return (
    <OnBoardHome />
  )
}

export default OnBoardPage;